import { useEffect, useRef } from 'react';
import { useAppSelector } from './redux';
import { apiClient, API_BASE_URL } from '../services/api';

export const useBrowsingTracker = (brandId?: number) => {
  const { isAuthenticated } = useAppSelector(state => state.auth);
  const startTimeRef = useRef<number>(Date.now());
  const sessionIdRef = useRef<string>(Math.random().toString(36).substring(7));

  useEffect(() => {
    if (!isAuthenticated || !brandId) return;

    startTimeRef.current = Date.now();

    // 页面卸载时记录访问
    const handleBeforeUnload = () => {
      const duration = Math.floor((Date.now() - startTimeRef.current) / 1000);

      // 使用 sendBeacon 确保数据发送
      if (navigator.sendBeacon && duration > 5) {
        const data = JSON.stringify({
          sessionId: sessionIdRef.current,
          duration,
        });

        navigator.sendBeacon(`${API_BASE_URL}/history/visit/${brandId}`, data);
      }
    };

    // 页面可见性变化时记录访问
    const handleVisibilityChange = () => {
      if (document.hidden) {
        const duration = Math.floor((Date.now() - startTimeRef.current) / 1000);
        if (duration > 5) {
          // 只记录停留超过5秒的访问
          apiClient
            .recordVisit(brandId, sessionIdRef.current, duration)
            .catch(() => undefined);
        }
      } else {
        startTimeRef.current = Date.now();
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      document.removeEventListener('visibilitychange', handleVisibilityChange);

      // 组件卸载时记录访问
      const duration = Math.floor((Date.now() - startTimeRef.current) / 1000);
      if (duration > 5) {
        apiClient
          .recordVisit(brandId, sessionIdRef.current, duration)
          .catch(() => undefined);
      }
    };
  }, [isAuthenticated, brandId]);

  return {
    sessionId: sessionIdRef.current,
    recordVisit: (customDuration?: number) => {
      if (!isAuthenticated || !brandId) return;

      const duration =
        customDuration ||
        Math.floor((Date.now() - startTimeRef.current) / 1000);
      return apiClient.recordVisit(brandId, sessionIdRef.current, duration);
    },
  };
};
